export const fatLevels = {
    low: 'Magro',
    medium: 'Padrão',
    high: 'Gordo',
  }
